export default __webpack_public_path__ + "static/media/card-identity-type-new.8738bb20.png";